// extracted by mini-css-extract-plugin
module.exports =  {"centered":"qlJ3zF","iconLabel":"jMkMYG"};